import Link from 'next/link';
import { ArrowRight } from '@/lib/icons';

interface RelatedPage {
  href: string;
  anchor: string;
  title: string;
}

interface RelatedContentProps {
  pages: RelatedPage[];
}

export function RelatedContent({ pages }: RelatedContentProps) {
  if (pages.length === 0) {
    return null;
  }

  return (
    <section className="mt-16 pt-12 border-t border-gray-200">
      <h2 className="text-3xl font-bold text-gray-900 mb-8">
        Related Resources
      </h2>
      
      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {pages.map((page, index) => (
          <Link
            key={index}
            href={page.href}
            className="group relative block p-6 bg-white border border-gray-200 rounded-lg hover:shadow-lg transition-all duration-300"
          >
            <div className="flex flex-col h-full">
              <h3 className="text-xl font-semibold text-gray-900 mb-2 group-hover:text-primary transition-colors">
                {page.title}
              </h3>
              
              <p className="text-gray-600 mb-4 flex-grow">
                Learn more about {page.anchor}
              </p>
              
              <div className="flex items-center text-primary font-medium">
                <span className="mr-2">Read More</span>
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}